import { DashboardErrorScreen } from '@/components/Error';
import { Reports, reportsSearchSchema } from '@/dashboards/Reports';
import { ReportsRouteProvider } from '@/dashboards/Reports/providers';
import {
    FEATURE_FLAG_ACTIONS,
    FEATURE_FLAG_SUBJECTS,
    withAuthorization,
} from '@/features/Casl';
import { FullPageLoader } from '@analytical-alley/ui';
import { createFileRoute } from '@tanstack/react-router';

const ReportsRouteComponent = () => {
    return (
        <ReportsRouteProvider routeId={Route.id}>
            <Reports />
        </ReportsRouteProvider>
    );
};

export const Route = createFileRoute(
    '/_org/project/$projectId/_dashboards/reports',
)({
    component: withAuthorization(
        ReportsRouteComponent,
        FEATURE_FLAG_ACTIONS.VIEW,
        FEATURE_FLAG_SUBJECTS.REPORTS_DASHBOARD,
    ),
    pendingComponent: FullPageLoader,
    validateSearch: reportsSearchSchema,
    errorComponent: DashboardErrorScreen,
});
